import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { EditorPage } from 'foundations-components/transitional/components/EditorPage';
import _isNil from 'hs-lodash/isNil';
import _omitBy from 'hs-lodash/omitBy';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { PageLayoutPropsContext } from '../../contexts/pageLayout/PropsContext';
import { defaultPageLayoutProps } from '../../contexts/pageLayout/constants';
import Header from './header/Header/Header';
import { jsx as _jsx } from "react/jsx-runtime";
function PageLayout({
  children
}) {
  const {
    recurringMeetings,
    useTheme,
    tabContainerHeight
  } = useContext(PageLayoutPropsContext);
  const scrollContainer = useRef(null);
  const [currentTabHeigth, setCurrentTabHeigth] = useState(0);
  const resizeHandler = useCallback(() => {
    if (scrollContainer.current && scrollContainer.current.parentElement) {
      setCurrentTabHeigth(scrollContainer.current.parentElement.offsetHeight);
    }
  }, [setCurrentTabHeigth]);
  const headerComponent = useMemo(() => /*#__PURE__*/_jsx(Header, {
    currentTabHeigth: currentTabHeigth
  }), [currentTabHeigth]);

  // if we have recurring meetings height of the tab changes
  // so we need to track this and calculate new height
  useEffect(() => {
    resizeHandler();
  }, [recurringMeetings, resizeHandler]);
  useEffect(() => {
    if (scrollContainer.current) {
      scrollContainer.current.style.height = tabContainerHeight;
      const parent = scrollContainer.current.parentElement;
      if (parent) {
        setCurrentTabHeigth(parent.offsetHeight);
      }
    }
  }, [tabContainerHeight]);
  useEffect(() => {
    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [resizeHandler]);
  return /*#__PURE__*/_jsx(EditorPage, {
    title: "Portal",
    headerComponent: headerComponent,
    use: useTheme,
    mainSectionFlush: true,
    scrollElementRef: scrollContainer,
    children: children
  });
}
const WrappedPageLayout = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const definedProps = _omitBy(props, _isNil);
  return /*#__PURE__*/_jsx(PageLayoutPropsContext.Provider, {
    value: Object.assign({}, defaultPageLayoutProps, definedProps),
    children: /*#__PURE__*/_jsx(PageLayout, {
      children: children
    })
  });
};
export default WrappedPageLayout;